(() => {
  if (customElements.get('aceii-product-sale-countdown')) return;

  customElements.define('aceii-product-sale-countdown', class extends HTMLElement {
    connectedCallback() {
      this.update();
      this.interval = window.setInterval(() => this.update(), 1000);
    }

    disconnectedCallback() {
      window.clearInterval(this.interval);
    }

    update() {
      // The announcement is the single source of truth, including editor changes.
      const source = document.querySelector('.hdt-announcement-sale hdt-countdown[config]');
      let deadline = NaN;
      try {
        const config = JSON.parse(source?.getAttribute('config') || '{}');
        if (config.datetime) {
          deadline = new Date(config.datetime + (window.themeHDN?.settings?.shopTimezone || '')).getTime();
        }
      } catch (_) {
        // Missing or invalid announcement settings must not create a false deadline.
      }
      const remaining = Math.floor((deadline - Date.now()) / 1000);
      this.hidden = !Number.isFinite(remaining) || remaining <= 0;
      if (this.hidden) return;

      const units = {
        days: Math.floor(remaining / 86400),
        hours: Math.floor(remaining / 3600) % 24,
        minutes: Math.floor(remaining / 60) % 60,
        seconds: remaining % 60
      };
      for (const [unit, value] of Object.entries(units)) {
        const node = this.querySelector(`[data-sale-unit="${unit}"]`);
        const text = String(value).padStart(2, '0');
        if (node && node.textContent !== text) node.textContent = text;
      }
    }
  });
})();
